import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { CreateCompany } from 'app/dtos/company/create-company';
import { HttpHeaders } from '@angular/common/http';
import { CreateCompanies } from 'app/dtos/company/create-companies';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private httpClientService: HttpClientService) { }
  async getAllCompany(seacrh, page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Company,
      queryString: `search=${seacrh}&Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async getAllDetailCompany() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Company,
      action: "GetAllDetailCompany"
    });
    return await firstValueFrom(observable);
  }

  async getByIdCompany(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Company,
    }, id);
    return await firstValueFrom(observable);
  }

  async getByIdCompanyTransaction(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Company,
      action: "GetByIdCompanyTransaction"
    }, id);
    return await firstValueFrom(observable);
  }

  async createCompanies(createCompanies: CreateCompanies[]) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Company,
      action: "CreateCompanies"
    }, createCompanies);
    return await firstValueFrom(observable);
  }

  async createCompany(createCompany: CreateCompany) {
    const formData = new FormData();
    console.log(createCompany);
    // Append form fields to FormData
    formData.append('companyName', createCompany.companyName);
    formData.append('address', createCompany.address || '');
    formData.append('phoneNumber', createCompany.phoneNumber || '');
    formData.append('phoneNumber2', createCompany.phoneNumber2 || '');
    formData.append('taxNumber', createCompany.taxNumber || '');
    formData.append('taxAdministration', createCompany.taxAdministration || '');
    formData.append('mail', createCompany.mail || '');
    formData.append('futuresDay', createCompany.futuresDay.toString());
    formData.append('discountRate', createCompany.discountRate?.toString());
    formData.append('description', createCompany.description || '');
    formData.append('categoryId', createCompany.categoryId?.toString() || '');
    formData.append('currencyId', createCompany.currencyId?.toString() || '');
    formData.append('districtId', createCompany.districtId?.toString() || '');
    formData.append('Name', createCompany.Name?.toString() || '');
    formData.append('Surname', createCompany.Surname?.toString() || '');
    formData.append('DVAccountType', createCompany.DVAccountType.toString() || '');
    formData.append('TurkakId', createCompany.TurkakId?.toString() || '');
    formData.append('ProvinceId', createCompany.provinceId?.toString() || '');
    if (createCompany.labels && createCompany.labels.length > 0) {
      for (let label of createCompany.labels) {
        formData.append('labels[]', label);
      }
    }
    if (createCompany.files && createCompany.files.length) {
      createCompany.files.forEach((file, index) => {
        formData.append('formFiles', file, file.name || `file${index}`);
      });
    }

    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Company,
    }, formData);
    return await firstValueFrom(observable);
  }

  async updateCompany(createCompany: CreateCompany) {
    console.log("update company :" + createCompany);
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Company,
    }, {
      id: createCompany.id,
      companyName: createCompany.companyName,
      address: createCompany.address,
      phoneNumber: createCompany.phoneNumber,
      phoneNumber2: createCompany.phoneNumber2,
      taxNumber: createCompany.taxNumber,
      futuresDay: createCompany.futuresDay,
      taxAdministration: createCompany.taxAdministration,
      mail: createCompany.mail,
      discountRate: createCompany.discountRate,
      description: createCompany.description,
      categoryId: createCompany.categoryId,
      labels: createCompany.labels,
      currencyId: createCompany.currencyId,
      districtId: createCompany.districtId,
      name: createCompany.Name,
      surname: createCompany.Surname,
      dvAccountType: createCompany.DVAccountType,
      turkakId: createCompany.TurkakId,
      acraditionCompanyId:createCompany.acraditionCompanyId,
      provinceId:createCompany.provinceId
    });
    return await firstValueFrom(observable);
  }

  async getCompanyFileId(id) {
    const observable: Observable<any> = this.httpClientService.get({
      action: "GetByFileCompanyId",
      controller: ControllerType.Company
    }, id);
    return await firstValueFrom(observable);
  }

  async changeCompanyFileShowcase(companyId, fileId) {
    const observable: Observable<any> = this.httpClientService.put({
      action: "ChangeShowcaseImage",
      controller: ControllerType.Company
    }, {
      companyId: companyId,
      fileId: fileId
    });
    return await firstValueFrom(observable);
  }

  async RemoveCompanyFile(companyId, fileId) {
    const observable: Observable<any> = this.httpClientService.get({
      action: "RemoveImage",
      controller: ControllerType.Company,
      queryString: `CompanyId=${companyId}&FileId=${fileId}`
    });
    return await firstValueFrom(observable);
  }

  async getCompany(){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Company,
      action:"GetCompany"
    });
    return await firstValueFrom(observable);
  }
  
  async getByIdCompanyBalance(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Company,
      action:"GetByIdCompanyBalance"
    },id);
    return await firstValueFrom(observable);
  }

  async getByIdCustomerDetail(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Company,
      action:"GetByIdCustomerDetail"
    },id);
    return await firstValueFrom(observable);
  }

  async sendCompanyMail(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Company,
      action:"SendCompanyMail"
    },id);
    return await firstValueFrom(observable);
  }
  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
